import { Group } from '@/router/group.model';
import {
  myBusinessProfile,
  manageTeam,
  manageLocations,
  integrations,
  coinImage,
  coinNetworkPlan
} from '@/router/routes';

const routes = [
  myBusinessProfile,
  coinImage,
  coinNetworkPlan,
  manageTeam,
  manageLocations,
  integrations
];

const businessMenuGroup = new Group('Business', 'business-menu', routes, {
  superRoot: false,
  hidden: true
});

export { businessMenuGroup };
export default businessMenuGroup;
